import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, XIcon } from 'lucide-react';
const names = ['María L.', 'Juan C.', 'Luciana G.', 'Martín R.', 'Carolina S.', 'Diego F.', 'Valeria M.', 'Sebastián P.', 'Florencia T.', 'Nicolás B.', 'Andrea V.', 'Pablo H.', 'Romina D.', 'Facundo A.', 'Gabriela N.', 'Alejandro K.', 'Daniela O.', 'Fernando E.', 'Soledad I.', 'Gustavo W.', 'Laura Z.', 'Hernán J.', 'Natalia Q.', 'Rodrigo U.', 'Cecilia X.'];
const cities = ['Mexico City', 'Bogotá', 'Lima', 'Santiago', 'Buenos Aires', 'Guadalajara', 'Medellín', 'Monterrey', 'Quito', 'Guayaquil', 'Montevideo', 'Asunción', 'San José', 'Panama City', 'Santo Domingo', 'Córdoba', 'Rosario', 'Cali', 'Arequipa', 'Puebla', 'Valparaíso', 'Barranquilla', 'La Paz'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    function showNotification() {
      setData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        setVisible(false);
      }, 4000);
    }
    // First popup after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 35-50 seconds
    const interval = setInterval(showNotification, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-381" data-mp="1a1txwoipze2s">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -40
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-4 z-[60] max-w-[300px] md:bottom-6" role="status" aria-live="polite" data-id="element-382" data-mp="1a2lm3e9zm9j1">
          <div className="bg-slate-900/95 backdrop-blur-md rounded-2xl shadow-2xl shadow-black/50 border border-white/10 p-3.5 flex items-start gap-3" data-id="element-383" data-mp="1r0v7iws64xpj">
            <div className="w-9 h-9 bg-emerald-500/15 rounded-full flex items-center justify-center shrink-0" data-id="element-384" data-mp="20rpqnsa4bh6r">
              <ShoppingBag size={17} className="text-emerald-400" aria-hidden="true" data-id="element-385" data-mp="24si2mtadk06q" />
            </div>
            <div className="min-w-0" data-id="element-386" data-mp="29tz16i5dzak5">
              <p className="text-sm font-semibold text-white leading-tight" data-id="element-387" data-mp="2es0jh0uzn5uk">
                {data.name} from {data.city}
              </p>
              <p className="text-xs text-slate-300 mt-0.5" data-id="element-388" data-mp="fgg8blmawg56">
                just purchased{' '}
                <span className="font-semibold text-sky-400" data-id="element-389" data-mp="kfarwps3e8qc">
                  Functional Fitness 365
                </span>
              </p>
              <p className="text-[11px] text-slate-500 mt-1" data-id="element-390" data-mp="cwjlsd4o1oip">
                {data.minutes} minutes ago
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-slate-500 hover:text-white transition-colors duration-150 ml-auto shrink-0 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" aria-label="Close notification" data-id="element-391" data-mp="34447gxa71yc">
              <XIcon size={14} aria-hidden="true" data-id="element-392" data-mp="vr8cburo7wec" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}